import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss']
})
export class FilterDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() filter: { from: number; to: number } = { from: null, to: null };
  @Input() dialogTitle: string = '';
  @Input() dialogType: string = '';

  @Output() filterReset = new EventEmitter<string>();
  @Output() filterApplied = new EventEmitter<{ from: number; to: number; type: string }>();

  rangeValues: number[] = [0, 9000000];
  minValue = 0;
  maxValue = 9000000;


  constructor() {}

  ngOnInit(): void {
    this.setDefaultValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.displayDialog && this.displayDialog) {
      this.setDefaultValues();
    }

    if (changes.filter && changes.filter.currentValue) {
      this.updateSliderValues();
    }
  }

  setDefaultValues() {
    if (this.filter.from === null) {
      this.filter.from = this.minValue;
    }
    if (this.filter.to === null) {
      this.filter.to = this.maxValue;
    }
    this.updateSliderValues();
  }

  updateSliderValues() {
    this.rangeValues = [this.filter.from, this.filter.to];
  }

  onFromChange(newValue: number) {
    this.filter.from = newValue;
    this.updateSliderValues();
  }

  onToChange(newValue: number) {
    this.filter.to = newValue;
    this.updateSliderValues();
  }

  resetFilter() {
    this.filter = { from: null, to: null };
    this.setDefaultValues();
    this.filterReset.emit(this.dialogType);
  }

  applyFilter() {
    this.filterApplied.emit({ ...this.filter, type: this.dialogType });
  }

  handleChange(event) {
    this.filter.from = this.rangeValues[0];
    this.filter.to = this.rangeValues[1];
  }
}
